import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import date from "@common/lib/date";
import { DUMMY_ORDER } from "../OrderConfirmation/lib";
import {
  Actions,
  type GetDetailBeginActionData,
  type GetDetailSuccessActionData,
  type InitSuccessActionData,
  type SetShowingDetailIdActionData,
  type UpdateDetailFailureActionData
} from "./actions";
import { type MemberRecurringOrders } from "./types";

const reducer = (
  state: MemberRecurringOrders.AppState = defaultState,
  action: ReduxAction<any>
): MemberRecurringOrders.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { items } = action.data as InitSuccessActionData;
      return {
        ...state,
        items,
        status: Status.Ready
      };
    }
    case Actions.GetDetailBegin: {
      const { itemId } = action.data as GetDetailBeginActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [itemId]: {
            detail: null,
            error: null,
            status: Status.Loading
          }
        },
        showingDetailId: itemId
      };
    }
    case Actions.GetDetailFailure: {
      const { error } = action.data as FailureActionData;
      const { itemId } = action.params as GetDetailBeginActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [itemId]: {
            detail: null,
            error,
            status: Status.Failed
          }
        }
      };
    }
    case Actions.GetDetailSuccess: {
      const { itemId } = action.params as GetDetailBeginActionData;
      const detail = action.data as GetDetailSuccessActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [itemId]: {
            detail: {
              ...detail,
              canChangeStatus: false
            },
            error: null,
            status: Status.Ready
          }
        }
      };
    }
    case Actions.SetShowingDetailId: {
      const { itemId } = action.data as SetShowingDetailIdActionData;
      return {
        ...state,
        showingDetailId: itemId
      };
    }
    case Actions.UpdateDetailBegin: {
      return {
        ...state,
        error: null,
        status: Status.Saving
      };
    }
    case Actions.UpdateDetailFailure: {
      const { error } = action.data as UpdateDetailFailureActionData;
      return {
        ...state,
        error,
        status: Status.Failed
      };
    }
    case Actions.UpdateDetailSuccess: {
      return {
        ...state,
        showingDetailId: null,
        error: null,
        status: Status.Ready
      };
    }
    default:
      return state;
  }
};

export const defaultState: MemberRecurringOrders.AppState = {
  error: null,
  id: "",
  status: Status.None,
  items: [],
  detail: {},
  showingDetailId: null
};
export const previewState: MemberRecurringOrders.AppState = {
  ...defaultState,
  status: Status.Ready,
  items: [
    {
      id: "dummy",
      nextRepeatDate: date.formatDate(date.add(new Date().toString(), 1, "Month"))!,
      number: DUMMY_ORDER.order.number,
      productName: "Dummy",
      productVariantName: "Dummy",
      statusName: "Dummy"
    }
  ]
};
export default wrapReducer({ defaultState, reducer, previewState });
